import _ from 'lodash'
import React, {PureComponent} from 'react'
import styled from 'styled-components'
import { Button } from './Buttons'

export default class Slide extends PureComponent {
  componentDidMount() {
    if (!this.props.image) {
      this.props.onReady()
    }
  }

  render() {
    const {title, subtitle, image, image_link, buttons, onButtonClick} = this.props

    let slideImage = image && <Image aria-label={title} alt="" src={image} onLoad={() => {
      this.props.onReady()
    }} />

    slideImage = slideImage && image_link ? <a href={image_link} target="_blank">{slideImage}</a> : slideImage
    const defaultTitle = title.toLowerCase() === 'welcome'
    return (
      <Container role="list">
        { slideImage }
        {!defaultTitle && <Title>{title}</Title>}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        {!_.isEmpty(buttons) && buttons.map(btnProps => (
          <Button key={`slide_btn_${Math.random()}`} {...btnProps} onButtonClick={onButtonClick} />
        ))}
      </Container>
    )
  }
}

const Container = styled.ul`
  background-color: ${props => props.theme.botBubbleBG};
  border-radius: 10px;
  padding: 15px;
  text-align: center;
  min-height: 20px;
  margin-left: 10%;
  margin-right: 10%;
  ${({theme}) => theme.bot_msg_container_css}
`

const Image = styled.img`
  width: 100%;
  max-height: 200px;
  margin-bottom: 5px;
`

const Title = styled.div`
  font-size: 1.3em;
  text-align: left;
`

const Subtitle = styled.div`
  font-size: 1em;
  text-align: left;
`



// WEBPACK FOOTER //
// ./src/ChatWidget/components/Carousel/Slide.js